import Vue from 'vue'
import { initEmbed } from '@/embed'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locales'
import { utilV2 } from '@/serves/http'
import ApiPath from '@/serves/path'
import VConsole from 'vconsole'
import { isMobile } from '@/utils/browser'
import * as Sentry from '@sentry/vue'
const env = process.env.NODE_ENV

/**
 * 端内初始化：把原生注入的 token 写进 localStorage、设置安全区与 RTL。
 *
 * 位置在所有 import 之后是有意的 —— ESM 的 import 会被提升，写在 import 之间
 * 并不会让它更早执行，反而误导人。这里够早的依据是：token 由 http.js 的请求
 * 拦截器每次现读（http.js:88），而首个请求发生在 Vue 挂载之后。
 * 语言则不同，必须更早，所以放在 public/index.html 的内联脚本里。
 */
initEmbed()
// 加载全部svg图标
import '@/icons/index'

// 加载自定义插件
import CustomPlugin from '@/utils/install'
Vue.use(CustomPlugin)

// 加载自定义组件库1
import UiPlugin from '@/components/mui/index'
Vue.use(UiPlugin)

// 加载自定义组件库2
import baseUI from '@/components/ui'
Vue.use(baseUI)

// 引入element-ui
import './utils/element-ui-import'
// import ElementLocale from "element-ui/lib/locale";
// ElementLocale.i18n((key, value) => i18n.t(key, value));

// 引入material-ui
import './utils/material-ui-import'

// 加载全局样式
import '@/styles/index.scss'
// 加载RTL支持
import '@/styles/rtl.scss'
// 初始化RTL支持
import { initRTLSupport } from '@/utils/rtl'
// 引入vconsole
if (env !== 'production' && isMobile) {
  new VConsole()
}
// 引入sentry
if (env !== 'development') {
  Sentry.init({
    Vue,
    dsn: 'https://b46f651e7346ff317f9a9214970650b1@o4511064865964032.ingest.de.sentry.io/4511064882806864',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: process.env.VUE_APP_SENTRY_ENV,
    release: 'mock-test-web@' + process.env.VUE_APP_VERSION || '1.0.0', // 版本号
    beforeSend(event) {
      // 标记移动端错误，方便筛选
      if (window.innerWidth < 768) {
        event.tags = { ...event.tags, platform: 'mobile' }
      }
      return event
    },
  })
}
import generalQuestionType from '@/components/generalQuestionType'
Vue.use(generalQuestionType)

import hsk from '@/components/hsk'

Vue.use(hsk)

window.utilV2 = utilV2
window.ApiPath = ApiPath

Vue.config.productionTip = false

// 初始化RTL支持
initRTLSupport()

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
